import {
  AnyType,
  FILTER_CONTROLLER_EVENTS,
  FiltersController,
  IPredicate,
  Select,
  useSyncFilterValue,
} from '@centra/centra-ui'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { AccountManagerOption } from '../../FilterComponent/AccountManagerOption/AccountManagerOption'
import { getQueryObjFromPredicates, getSelectOptionsAndSetValue, updatePredicates } from '../../FilterComponent/utils'

import styled from './FilterComponentOptions.module.scss'

interface IFilterComponentOptionsProps {
  filterName: string
  predicate: IPredicate[]
  controller: FiltersController
  query: string
  notInModal?: boolean
  label?: string
}

export const FilterComponentOptions: FC<IFilterComponentOptionsProps> = ({
  filterName,
  predicate,
  controller,
  query,
  notInModal,
  label,
}) => {
  const [selectValue, setSelectValue] = useState<AnyType[]>([])
  const isAccountManagerFilter = filterName === 'accountManagerIds'
  const scheme = useSyncFilterValue({ controller, event: FILTER_CONTROLLER_EVENTS.SCHEME })
  const activeFilter = scheme.get(filterName)

  const options = useMemo(() => {
    if (activeFilter && activeFilter.type === 'options') {
      return activeFilter?.options
    }
  }, [activeFilter])

  useEffect(() => {
    if (!predicate.length) {
      setSelectValue([])
    }

    if (notInModal) {
      const queryObj = getQueryObjFromPredicates(predicate)
      const filteredArray = opt?.filter(obj => (queryObj[filterName] as number[])?.includes(obj.id))
      if (filteredArray) setSelectValue(filteredArray)
    }
  }, [predicate])

  useEffect(() => {
    if (activeFilter?.type === 'options') {
      controller.loadOption(activeFilter)
    }
  }, [])

  const opt = useMemo(() => {
    if (!options) return undefined
    const selectOptions = getSelectOptionsAndSetValue({
      options,
      query,
      filterName,
      setSelectValue,
    })
    return selectOptions
  }, [options])

  const handleSelectChange = (v: AnyType) => {
    setSelectValue(v)
    updatePredicates({ predicate, v, filterName, controller })
  }
  return (
    <Select
      id={`${filterName}FilterSingleSelect`}
      staticLabel={label ? label : undefined}
      noSelectedOptions={notInModal ? notInModal : undefined}
      setMenuMaxWidth={notInModal ? 400 : undefined}
      size={notInModal ? 'sm' : 'md'}
      isMulti
      options={opt}
      onChange={handleSelectChange}
      value={selectValue}
      className={notInModal ? styled.selectGap : ''}
      isClearable={!notInModal}
      getValue={isAccountManagerFilter ? data => data.value : undefined}
      //@ts-ignore
      getOptionLabel={isAccountManagerFilter ? data => <AccountManagerOption data={data} /> : undefined}
    />
  )
}
